import { defineMessages } from 'react-intl';

export const messages: {
	'atlassian-web-crawler': {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	['atlassian-web-crawler']: {
		id: 'search-page.products.custom-website',
		defaultMessage: 'Web page',
		description:
			'The text is shown as the display name for the Atlassian Web Crawler connector option in the search product configuration UI.',
	},
});
